import React from "react";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Permission from "../../components/Common/Permission";
import FilterButton from "../../components/Common/FilterButton";
import styled from "styled-components";
import Button from "sushiweb/Button";
import * as IssueTypesActions from "../../store/actions/IssueTypes";
import * as UserActions from "../../store/actions/User";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IssueTypeList from "../../components/LogisticsSupport/IssueTypeList/index";
import ListPagination from "../../components/Common/ListPagination";
import { useHistory } from "react-router-dom";
import IssueTypeFilterModal from "../../components/LogisticsSupport/IssueTypeList/IssueTypeFilterModal";

const IssueTypes = ({
  getIssueTypeList,
  issueTypeList,
  prevPage,
  nextPage,
  activeFilters,
  setSideBarCollapsed,
}) => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [showFilterModal, setShowFilterModal] = React.useState(false);
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD];
  React.useEffect(() => {
    if (issueTypeList.length === 0) {
      getIssueTypeList(currentPage, {});
    }
    setSideBarCollapsed(true);
  }, []);

  const handleClick = (action) => {
    if (action === "Add") {
      history.push("/issue-types/create");
    } else {
      setShowFilterModal(true);
    }
  };
  const handleModalClose = () => {
    setShowFilterModal(false);
  };
  const handleNavClick = (action) => {
    if (action === "prev") {
      getIssueTypeList(currentPage - 1, activeFilters);
      setCurrentPage(currentPage - 1);
    } else {
      getIssueTypeList(currentPage + 1, activeFilters);
      setCurrentPage(currentPage + 1);
    }
  };
  return (
    <RiderIssueTypeViewContainer>
      <FlexContainer align="flex-start">
        <Heading>Issue Types</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={activeFilters}
              data-testid="issueTypeFilterButton"
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="issueTypeCreationButton"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <IssueTypeList issueTypeList={issueTypeList} currentPage={currentPage} />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {showFilterModal && (
        <IssueTypeFilterModal handleModalClose={handleModalClose} />
      )}
    </RiderIssueTypeViewContainer>
  );
};

const RiderIssueTypeViewContainer = styled.div``;

function mapStateToProps(state) {
  const { IssueTypes } = state;
  return {
    issueTypeList: IssueTypes.issueTypeList,
    nextPage: IssueTypes.nextPage,
    prevPage: IssueTypes.prevPage,
    activeFilters: IssueTypes.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getIssueTypeList: bindActionCreators(
      IssueTypesActions.getIssueTypeList,
      dispatch
    ),
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueTypes);
